<template>
	<div class="w-full">
		<div class="mb-3">
			<span class="mb-0 font-medium text-gray-650">Odometer</span>
		</div>

		<div v-if="isDirty" class="m-0 space-y-3 p-0">
			<FilterSelectbox
				v-model="odometerFrom"
				mode="single"
				:options="odometerFromOptions"
				value-prop="value"
				label="label"
				placeholder="From"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'odometerFrom')"
			/>

			<FilterSelectbox
				v-model="odometerTo"
				mode="single"
				:options="odometerToOptions"
				value-prop="value"
				label="label"
				placeholder="To"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'odometerTo')"
			/>
		</div>

		<div v-if="showContentLoader" class="content-loader-svg flex w-full">
			<!-- <ContentLoader viewBox="0 0 250 80">
				<rect x="0" y="0" rx="3" ry="3" width="100%" height="35" />
				<rect x="0" y="45" rx="3" ry="3" width="100%" height="35" />
			</ContentLoader> -->
			<ContentLoader width="w-full" height="h-[35px]" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import FilterSelectbox from '@/components/selectboxes/FilterSelectbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const odometerFrom = ref(
	productCatalog.filters.odometerFrom
		? productCatalog.filters.odometerFrom
		: 'all'
)
const odometerTo = ref(
	productCatalog.filters.odometerTo
		? productCatalog.filters.odometerTo
		: 'all'
)

const odometerFromOptionsOriginal = computed(
	() => productCatalog.facets.odometerFrom
)

const odometerToOptionsOriginal = computed(
	() => productCatalog.facets.odometerTo
)

const odometerFromOptions = computed(() => {
	const options = []
	odometerFromOptionsOriginal.value.forEach((option) => {
		if (
			odometerTo.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) >= parseInt(odometerTo.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const odometerToOptions = computed(() => {
	const options = []
	odometerToOptionsOriginal.value.forEach((option) => {
		if (
			odometerFrom.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) <= parseInt(odometerFrom.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

watch(
	() => productCatalog.filters.odometerFrom,
	(newValue) => {
		odometerFrom.value =
			newValue === null || newValue === '' ? 'all' : newValue
	}
)

watch(
	() => productCatalog.filters.odometerTo,
	(newValue) => {
		odometerTo.value =
			newValue === null || newValue === '' ? 'all' : newValue
	}
)

const onChange = (filterValue, filterKey) => {
	const updateFilterValue = filterValue === 'all' ? null : filterValue

	productCatalog.updateFilter({
		filterKey,
		filterValue: updateFilterValue,
	})
}
</script>
